module.exports = __webpack_public_path__ + "img/营收系统.138b536d.png";